import { ChangeEvent, FormEvent, useState } from "react";
import { LicenseCreate } from "../../models/Licenses/LicenseCreate";
import { Box, Button, TextField } from "@mui/material";

interface Props {
  selectedLicense: LicenseCreate;
  closeForm: () => void;
  edit: (license: LicenseCreate) => void;
}

export default function EditLicenseForm({
  selectedLicense,
  closeForm,
  edit,
}: Props) {
  const [licenseData, setLicenseData] =
    useState<LicenseCreate>(selectedLicense);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    edit(licenseData);
  }

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setLicenseData({ ...licenseData, [name]: value });
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        label="Start Date"
        name="startDate"
        value={licenseData.startDate}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        type="date"
        required
        slotProps={{ inputLabel: { shrink: true } }}
      />

      <TextField
        label="Valid Date"
        name="validDate"
        value={licenseData.validDate}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        type="date"
        required
        slotProps={{ inputLabel: { shrink: true } }}
      />

      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button type="submit" variant="contained" color="primary">
          Submit
        </Button>
        <Button variant="outlined" onClick={closeForm}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
